import React from 'react'

import Configuration from './configuration';

export default function Scripts() {
    return (
        <div class="scripts">

            <script src="https://code.jquery.com/jquery-3.1.1.min.js" integrity="sha256-hVVnYaiADRTO2PzUGmuLJr8BLUSjGIZsDYGmIJLv2b8=" crossorigin="anonymous"></script>

            <script type="text/javascript" src="https://maps.google.com/maps/api/js?key=AIzaSyDCj91m02CHBP0pFwEIqSYIWWMlmL4oTwc"></script>
            <script type="text/javascript" src={`${Configuration.WEB_PATH}js/plugins/neo/neo-maps/neo-maps-3.0.js`} ></script>

            <script type="text/javascript" src={`${Configuration.WEB_PATH}js/plugins/neo/neo-slider/neo-slider-3.0.js`} ></script>

            <script type="text/javascript" src={`${Configuration.WEB_PATH}js/plugins/neo/neo-carrousel/neo-carrousel-1.0.js`} ></script>

            <script type="text/javascript" src={`${Configuration.WEB_PATH}js/plugins/neo/neo-gallery/neo-gallery-4.0.js`} ></script>

            <script type="text/javascript" src={`${Configuration.WEB_PATH}js/plugins/neo/neo-scrolling/neo-scrolling-1.0.js`} ></script>

            <script type="text/javascript" src={`${Configuration.WEB_PATH}js/plugins/neo/neo-tabs/neo-tabs-1.0.min.js`} ></script>

            <script type="text/javascript" src={`${Configuration.WEB_PATH}js/plugins/ext/youtube/youtube.min.js`}></script>

            <script src='https://www.google.com/recaptcha/api.js?hl=<?= $lang; ?>'></script>

            <script type="text/javascript" src={`${Configuration.WEB_PATH}js/functions.js`}></script>
            
        </div>
    )
}
